.scrollable-container-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: var(--fdt-core-color-secondary-50);
}

.scrollable-container {
  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  position: relative;
  flex: 1;
}
.scrollable-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari and Opera */
}
.scrollable-container.at-start::before {
  opacity: 0;
}
.scrollable-container.at-end::after {
  opacity: 0;
}

.scrollable-container__nav {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 37.5px;
  height: 37.5px;
  background-color: var(--fdt-core-color-neutral-600);
  border: 1.25px solid var(--fdt-core-color-neutral-100);
  color: var(--fdt-core-color-neutral-100);
  border-radius: 50%;
  cursor: pointer;
  z-index: 3;
  transition: all 0.2s ease;
}
.scrollable-container__nav--left {
  left: 4px;
}
.scrollable-container__nav--right {
  right: 4px;
}

@media (min-width: 1024px) {
  .scrollable-container--desktop-no-scroll {
    overflow-x: visible;
  }
  .scrollable-container__nav--desktop-hidden {
    display: none;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */